import { memo, useState, useRef } from "react";
import { Play, Volume2, VolumeX } from "lucide-react";

interface VideoMessagePlayerProps {
  videoUrl: string;
  isOwnMessage: boolean;
}

const VideoMessagePlayer = memo(({ videoUrl, isOwnMessage }: VideoMessagePlayerProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);

  const togglePlay = () => {
    if (!videoRef.current) return;
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="relative w-48 h-64 rounded-xl overflow-hidden bg-black">
      <video
        ref={videoRef}
        src={videoUrl}
        className="w-full h-full object-cover"
        playsInline
        muted={isMuted}
        onEnded={() => setIsPlaying(false)}
        onClick={togglePlay}
      />

      {/* Play overlay */}
      {!isPlaying && (
        <button
          onClick={togglePlay}
          className="absolute inset-0 flex items-center justify-center bg-black/20"
        >
          <div className="w-12 h-12 rounded-full bg-white/30 backdrop-blur-sm flex items-center justify-center">
            <Play className="w-6 h-6 text-white fill-white ml-0.5" />
          </div>
        </button>
      )}

      {/* Mute toggle */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          setIsMuted(!isMuted);
        }}
        className="absolute bottom-2 right-2 w-8 h-8 rounded-full bg-black/50 flex items-center justify-center text-white"
      >
        {isMuted ? <VolumeX className="w-4 h-4" /> : <Volume2 className="w-4 h-4" />}
      </button>

      {/* Video badge */}
      <div className="absolute top-2 left-2 px-2 py-1 rounded-full bg-black/50 text-white text-xs flex items-center gap-1">
        <Play className="w-3 h-3 fill-current" />
        Video
      </div>
    </div>
  );
});

VideoMessagePlayer.displayName = "VideoMessagePlayer";

export default VideoMessagePlayer;
